import { PremiumFeature } from '@trello/product-features';

export const isStandardOrg = (product: number[] | number = []) =>
  [115, 116, 117, 118].includes(Array.isArray(product) ? product[0] : product);

export const isEnterpriseOrg = (premiumFeatures: PremiumFeature[] = []) => {
  return premiumFeatures.includes(PremiumFeature.EnterpriseUI);
};
